import {useEffect, useMemo, useRef, useState} from 'react';

import {Input, Slider, SliderWrapper, Track, ValueText, Wrapper} from './styles';

type RangeSliderProps = {
    min: number;
    max: number;
    value: Record<'min' | 'max', number>;
    onChange: (value: Record<'min' | 'max', number>) => void;
};

export const RangeSlider = ({min, max, value, onChange}: RangeSliderProps) => {
    const [minVal, setMinVal] = useState(value.min);
    const [maxVal, setMaxVal] = useState(value.max);
    const minValRef = useRef<HTMLInputElement>(null);
    const maxValRef = useRef<HTMLInputElement>(null);

    const thumbMinGapInSteps = useMemo(
        () => Math.round(8 / (180 / (max - min))),
        [min, max],
    );

    const handleMinValue = (ev: any) => {
        const value = Math.min(Number(ev.target.value), maxVal - thumbMinGapInSteps);
        setMinVal(value);
        return value;
    };
    const handleMaxValue = (ev: any) => {
        const value = Math.max(Number(ev.target.value), minVal + thumbMinGapInSteps);
        setMaxVal(value);
        return value;
    };

    const handleMinSlideEnd = (ev: any) => {
        const value = handleMinValue(ev);
        onChange({
            min: value,
            max: maxVal,
        });
    };
    const handleMaxSlideEnd = (ev: any) => {
        const value = handleMaxValue(ev);
        onChange({
            min: minVal,
            max: value,
        });
    };

    useEffect(() => {
        setMinVal(value.min);
        setMaxVal(value.max);
    }, [value]);

    return (
        <Wrapper>
            <ValueText>{`${minVal} m`}</ValueText>
            <SliderWrapper>
                <Input
                    type="range"
                    min={min}
                    max={max}
                    value={minVal}
                    ref={minValRef}
                    onChange={handleMinValue}
                    onMouseUp={handleMinSlideEnd}
                    onTouchEnd={handleMinSlideEnd}
                />
                <Input
                    type="range"
                    min={min}
                    max={max}
                    value={maxVal}
                    ref={maxValRef}
                    onChange={handleMaxValue}
                    onMouseUp={handleMaxSlideEnd}
                    onTouchEnd={handleMaxSlideEnd}
                />

                <Slider>
                    <Track />
                </Slider>
            </SliderWrapper>
            <ValueText>{`${maxVal} m`}</ValueText>
        </Wrapper>
    );
};
